export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158')
];

export const server_loads = [];

export const dictionary = {
		"/": [25],
		"/action/offerpendingend": [26],
		"/admin": [27,[2],[3]],
		"/admin/business": [29,[2],[3]],
		"/admin/business/create": [35,[2],[3]],
		"/admin/business/[id]": [30,[2,4],[3]],
		"/admin/business/[id]/details": [31,[2,4],[3]],
		"/admin/business/[id]/offers": [32,[2,4],[3]],
		"/admin/business/[id]/responses": [33,[2,4],[3]],
		"/admin/business/[id]/subscription": [34,[2,4],[3]],
		"/admin/charity": [36,[2],[3]],
		"/admin/charity/create": [41,[2],[3]],
		"/admin/charity/[id]": [37,[2,5],[3]],
		"/admin/charity/[id]/details": [38,[2,5],[3]],
		"/admin/charity/[id]/needs": [39,[2,5],[3]],
		"/admin/charity/[id]/requests": [40,[2,5],[3]],
		"/admin/login": [42],
		"/admin/needs": [45,[2,6],[3]],
		"/admin/needs/draft": [46,[2,6],[3]],
		"/admin/needs/ended": [47,[2,6],[3]],
		"/admin/needs/pending": [48,[2,6],[3]],
		"/admin/needs/published": [49,[2,6],[3]],
		"/admin/need/[id]": [43,[2],[3]],
		"/admin/need/[id]/edit": [44,[2],[3]],
		"/admin/offers": [53,[2,7],[3]],
		"/admin/offers/draft": [54,[2,7],[3]],
		"/admin/offers/ended": [55,[2,7],[3]],
		"/admin/offers/pending": [56,[2,7],[3]],
		"/admin/offers/published": [57,[2,7],[3]],
		"/admin/offer/[id]": [50,[2],[3]],
		"/admin/offer/[id]/edit": [51,[2],[3]],
		"/admin/offer/[id]/request/[requestId]": [52,[2],[3]],
		"/admin/org": [58,[2],[3]],
		"/admin/org/create": [66,[2],[3]],
		"/admin/org/[id]": [59,[2,8],[3]],
		"/admin/org/[id]/charity": [60,[2,8],[3]],
		"/admin/org/[id]/details": [61,[2,8],[3]],
		"/admin/org/[id]/needs": [62,[2,8],[3]],
		"/admin/org/[id]/offers": [63,[2,8],[3]],
		"/admin/org/[id]/plan": [64,[2,8],[3]],
		"/admin/org/[id]/sports": [65,[2,8],[3]],
		"/admin/settings/admins": [67,[2],[3]],
		"/admin/settings/admins/create": [69,[2],[3]],
		"/admin/settings/admins/[id]": [68,[2],[3]],
		"/admin/settings/claude": [70,[2],[3]],
		"/admin/settings/email_templates": [73,[2],[3]],
		"/admin/settings/email_template/create": [71,[2],[3]],
		"/admin/settings/email_template/view/[id]": [72,[2],[3]],
		"/admin/settings/general": [74,[2],[3]],
		"/admin/settings/operations": [75,[2],[3]],
		"/admin/settings/tags": [76,[2],[3]],
		"/admin/user": [77,[2],[3]],
		"/admin/user/create": [79,[2],[3]],
		"/admin/user/[id]": [78,[2],[3]],
		"/admin/[...rest]": [28,[2],[3]],
		"/business": [80,[9],[10]],
		"/business/needs": [83,[9],[10]],
		"/business/need/[id]": [82,[9],[10]],
		"/business/offers": [89,[9],[10]],
		"/business/offers/create": [90,[9],[10]],
		"/business/offer/[id]": [84,[9,11],[10]],
		"/business/offer/[id]/details": [85,[9,11],[10]],
		"/business/offer/[id]/edit": [86,[9,11],[10]],
		"/business/offer/[id]/matches": [87,[9,11],[10]],
		"/business/offer/[id]/requests": [88,[9,11],[10]],
		"/business/profile": [91,[9,12],[10]],
		"/business/profile/company": [92,[9,12],[10]],
		"/business/profile/contact": [93,[9,12],[10]],
		"/business/profile/delete": [94,[9,12],[10]],
		"/business/profile/preferences": [95,[9,12],[10]],
		"/business/profile/subscription": [96,[9,12],[10]],
		"/business/request/[requestId]": [97,[9],[10]],
		"/business/[...rest]": [81,[9],[10]],
		"/charity": [98,[13],[14]],
		"/charity/needs": [103,[13],[14]],
		"/charity/needs/create": [104,[13],[14]],
		"/charity/need/[id]": [100,[13,15],[14]],
		"/charity/need/[id]/details": [101,[13,15],[14]],
		"/charity/need/[id]/edit": [102,[13,15],[14]],
		"/charity/offer/[id]": [105,[13],[14]],
		"/charity/profile": [106,[13,16],[14]],
		"/charity/profile/charity": [107,[13,16],[14]],
		"/charity/profile/contact": [108,[13,16],[14]],
		"/charity/profile/link": [109,[13,16],[14]],
		"/charity/profile/settings": [110,[13,16],[14]],
		"/charity/requests": [111,[13],[14]],
		"/charity/[...rest]": [99,[13],[14]],
		"/goodbye": [112],
		"/org": [113,[17]],
		"/org/account": [115,[17,18]],
		"/org/account/details": [116,[17,18]],
		"/org/account/organisation": [117,[17,18]],
		"/org/account/plan": [118,[17,18]],
		"/org/needs": [122,[17]],
		"/org/needs/browse": [123,[17]],
		"/org/needs/create": [124,[17]],
		"/org/needs/responses": [125,[17]],
		"/org/need/[id]": [119,[17]],
		"/org/need/[id]/(manage)/details": [120,[17,19]],
		"/org/need/[id]/edit": [121,[17]],
		"/org/offers": [131,[17]],
		"/org/offers/browse": [132,[17]],
		"/org/offers/create": [133,[17]],
		"/org/offer/[id]": [126,[17]],
		"/org/offer/[id]/(manage)/details": [127,[17,20]],
		"/org/offer/[id]/edit": [130,[17]],
		"/org/offer/[id]/(manage)/matches": [128,[17,20]],
		"/org/offer/[id]/(manage)/requests": [129,[17,20]],
		"/org/requests": [135,[17]],
		"/org/request/[requestId]": [134,[17]],
		"/org/[...rest]": [114,[17]],
		"/public": [136,[21],[22]],
		"/public/needs": [138,[21],[22]],
		"/public/needs/need/[needid]": [139,[21],[22]],
		"/public/offer/[id]": [140,[21],[22]],
		"/public/[...rest]": [137,[21],[22]],
		"/recover": [141],
		"/redirect/complete": [142,[23]],
		"/signup": [143],
		"/sport": [144],
		"/sport/signup": [145],
		"/start": [146,[24]],
		"/start/business/org": [147,[24]],
		"/start/business/personal": [148,[24]],
		"/start/charity/personal": [149,[24]],
		"/start/charity/ready": [150,[24]],
		"/start/charity/types/cbs": [152,[24]],
		"/start/charity/types/cic": [153,[24]],
		"/start/charity/types/engwalesregistered": [154,[24]],
		"/start/charity/types/hmrc": [155,[24]],
		"/start/charity/types/northernireland": [156,[24]],
		"/start/charity/types/scotlandregistered": [157,[24]],
		"/start/charity/types/unregistered": [158,[24]],
		"/start/charity/type": [151,[24]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';